import { render } from "./PlaylistComponent.vue?vue&type=template&id=74f07568&scoped=true"
import script from "./PlaylistComponent.vue?vue&type=script&lang=js"
export * from "./PlaylistComponent.vue?vue&type=script&lang=js"

import "./PlaylistComponent.vue?vue&type=style&index=0&id=74f07568&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74f07568"]])

export default __exports__